import Analytics from './Analytics';

export default function AdminDashboard() {
  return <Analytics />;
}
